// libs
import React from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// components
import SelectBoxNext from '@/components/SelectBox';
import { KeywordMatchType } from '@local/typedefs/dist/protos/campaign/Criteria';
// helpers
import { getMatchTypeString } from '@/pages/instamart/campaign/create/widgets/Steps/Keywords/helpers';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// icons
import IconChevronDown from '@/constants/icons/svg/ChevronDown';
// styles
import styles from './MatchTypeSelector.module.scss';
const options = [
    {
        matchType: KeywordMatchType.KEYWORD_MATCH_TYPE_BROAD,
    },
    {
        matchType: KeywordMatchType.KEYWORD_MATCH_TYPE_EXACT,
    },
];
function MatchTypeSelector(props) {
    const { row, selectedMatchType, onChange } = props;
    const [selectBoxState, setSelectBoxState] = React.useState(false);
    const matchTypeCta = selectedMatchType === KeywordMatchType.KEYWORD_MATCH_TYPE_BROAD
        ? 'Broad Match'
        : 'Exact Match';
    const handleChange = (options) => {
        const selectedOption = options.find((option) => option.selected);
        selectedOption && onChange(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.item.matchType);
    };
    const handleSelectBoxState = () => {
        setSelectBoxState(!selectBoxState);
    };
    const renderFunction = (option, index, onClick) => {
        const variant = option.selected
            ? DlsFontVariants.body_B1_Bold
            : DlsFontVariants.body_B1_Med;
        const color = option.selected
            ? DlsColorTokens.text_High_Emphasis
            : DlsColorTokens.text_Med_Emphasis;
        return (React.createElement(Text, { variant: variant, color: color, onClick: onClick, className: styles.matchTypeSelectorOption }, getMatchTypeString(option.item.matchType)));
    };
    const getIdentifier = (option) => option.matchType;
    return (React.createElement(SelectBoxNext, { identifier: getIdentifier, renderFunction: renderFunction, onChange: handleChange, options: options, value: selectedMatchType, actionClassName: styles.matchTypeSelectorCtaWrapper, className: styles.matchTypeSelector, autoUpdatePosition: true },
        React.createElement("div", { onClick: handleSelectBoxState, className: styles.matchTypeSelectorCta },
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Med }, matchTypeCta),
            React.createElement(IconChevronDown, { fillColor: '#02060C', className: cx(styles.icon), height: 12, width: 12 }))));
}
export default MatchTypeSelector;
